export const TRANSLATION_DELAY = 500;
